import React, { CSSProperties, FC } from 'react'

const LoaderSpin: FC<{
 className?: string
 mtsMode?: boolean
}> = ({ className, mtsMode }) => (
 <div style={mtsMode ? loaderStyle : {}} className={className ?? ''}>
  <i className="fas fa-spin fa-spinner" />
 </div>
)

export default LoaderSpin

const loaderStyle: CSSProperties = {
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 width: '100%',
 height: '100%',
}
